/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AttachmentScope } from '../../models/attachment-scope';

export interface DownloadWorkPackageStorageObjects$Params {
  assetId?: string | null;
  contentTypes?: Array<string>;
  name?: string;
  scopes?: Array<AttachmentScope>;
  projectIds?: Array<string>;
  workPackageIds?: Array<string>;
  parentId?: string;
  query?: string;
  createdById?: string | null;
  assigneeIds?: Array<string>;
  typeIds?: Array<string>;
  priorityIds?: Array<string>;
  statusIds?: Array<string>;
  categoriesIds?: Array<string>;
  groupIds?: Array<string>;
  dynamicFilters?: string;
  isExpired?: boolean | null;
  startFrom?: string | null;
  startTo?: string | null;
  endFrom?: string | null;
  endTo?: string | null;
  ids?: Array<string>;
}

export function downloadWorkPackageStorageObjects(http: HttpClient, rootUrl: string, params?: DownloadWorkPackageStorageObjects$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
  const rb = new RequestBuilder(rootUrl, downloadWorkPackageStorageObjects.PATH, 'get');
  if (params) {
    rb.query('assetId', params.assetId, {});
    rb.query('contentTypes', params.contentTypes, {});
    rb.query('name', params.name, {});
    rb.query('scopes', params.scopes, {});
    rb.query('projectIds', params.projectIds, {});
    rb.query('workPackageIds', params.workPackageIds, {});
    rb.query('parentId', params.parentId, {});
    rb.query('query', params.query, {});
    rb.query('createdById', params.createdById, {});
    rb.query('assigneeIds', params.assigneeIds, {});
    rb.query('typeIds', params.typeIds, {});
    rb.query('priorityIds', params.priorityIds, {});
    rb.query('statusIds', params.statusIds, {});
    rb.query('categoriesIds', params.categoriesIds, {});
    rb.query('groupIds', params.groupIds, {});
    rb.query('dynamicFilters', params.dynamicFilters, {});
    rb.query('isExpired', params.isExpired, {});
    rb.query('startFrom', params.startFrom, {});
    rb.query('startTo', params.startTo, {});
    rb.query('endFrom', params.endFrom, {});
    rb.query('endTo', params.endTo, {});
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<any>;
    })
  );
}

downloadWorkPackageStorageObjects.PATH = '/v0/files/work-packages/download';
